import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try {
      const raw = localStorage.getItem("ff_user");
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  });
  const [token, setToken] = useState(() => localStorage.getItem("ff_token"));
  const [ready, setReady] = useState(false);

  const persist = useCallback((tk, usr) => {
    if (tk) localStorage.setItem("ff_token", tk);
    else localStorage.removeItem("ff_token");
    if (usr) localStorage.setItem("ff_user", JSON.stringify(usr));
    else localStorage.removeItem("ff_user");
    setToken(tk || null);
    setUser(usr || null);
  }, []);

  useEffect(() => {
    let alive = true;
    (async () => {
      if (token) {
        try {
          const me = await api.me();
          if (alive) persist(token, me);
        } catch {
          if (alive) persist(null, null);
        }
      }
      if (alive) setReady(true);
    })();
    return () => { alive = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const accent = user?.accent_color || "sunset-orange";
    document.documentElement.setAttribute("data-accent", accent);
    document.documentElement.classList.add("dark");
  }, [user]);

  const login = async (email, password) => {
    const res = await api.login({ email, password });
    persist(res.token, res.user);
    return res.user;
  };
  const register = async (payload) => {
    const res = await api.register(payload);
    persist(res.token, res.user);
    return res.user;
  };
  const logout = () => persist(null, null);
  const refreshMe = async () => {
    const me = await api.me();
    persist(token, me);
    return me;
  };
  const updateProfile = async (patch) => {
    const me = await api.updateMe(patch);
    persist(token, me);
    return me;
  };

  return (
    <AuthContext.Provider value={{ user, token, ready, login, register, logout, refreshMe, updateProfile, setUser: (u) => persist(token, u) }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
